import { z } from "zod";
import { CatalogArticleItem } from "./Storyblok";

export const ArticleInquiry = z.object({
    article: CatalogArticleItem.partial({ fullSlug: true }),
    themeOrCategory: z.string().optional(),
});

export type ArticleInquiry = z.infer<typeof ArticleInquiry>;
